export type CreatedByUser = {
	firstName: string,
	lastName: string,
}

function render( createdByUser: CreatedByUser ) {
	return `${createdByUser.firstName} ${createdByUser.lastName}`
}

export default {
	field: 'createdByUser',
	name: 'Created By',
	render,
}
